(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-cart"]) return;
  try {
    
    window.check_subscribeAGB = function(event = null) {
      const form_submit = document.querySelector('form.quick-cart__form button[type="submit"]');
      let subscribeAGB_status = false;
      
      if (event) {
        subscribeAGB_status = event.target.checked;
      } else {
        const checkbox_subscribeAGB = document.querySelector('form.quick-cart__form input[type="checkbox"][id="subscribeAGB"]');
        subscribeAGB_status = checkbox_subscribeAGB?.checked || false;
      }
      
      if (form_submit) {
        form_submit.disabled = !subscribeAGB_status;
      }
    };

    document.addEventListener('DOMContentLoaded', check_subscribeAGB);

  } catch(e) { console.error(e); }
})();
})();
